import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
  AfterViewInit,
  Input,
  ChangeDetectorRef,
} from '@angular/core';
import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService, ErrorsHandlerService, PageLoadingService } from '@lib/services';
import lottie, { AnimationItem } from 'lottie-web';
import { iconJson } from './icon_json.data';
import { ComplexFlightAvailabilityRequestService } from '@app/complex-flight-availability/service/request.service';
import { ComplexFlightAvailabilityStoreService } from '@app/complex-flight-availability/service/store.service';
import { DataAdapterService } from '@app/complex-flight-availability/service/data-adapter.service';
import { FavoritePostService } from '@common/services/api-store/sdk-search/favorite-post/favorite-post-store.service';
import { RoundtripFlightAvailabilityInternationalPresService } from '@app/roundtrip-flight-availability-international/presenter/roundtrip-flight-availability-international-pres.service';
import { RoundtripFlightAvailabilityInternationalService } from '@common/services/roundtripFlightAvailabilityInternational/roundtripFlightAvailabilityInternational.service';

@Component({
  selector: 'asw-add-to-favorite',
  templateUrl: './add-to-favorite.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddToFavoriteComponent extends SupportComponent implements AfterViewInit {
  private _animationAddToFavorite?: AnimationItem;
  // 画面描画用  お気に入り登録済み
  public favoriteFlag = false;

  // お気に入りボタンの状態
  public isFavoriteAdded = false;
  /** お気に入り追加ボタンアニメーションが不要か */
  public isNotFavoriteAnimation?: boolean;
  /** 連打防止用 */
  public disabled: boolean = false;

  @Input()
  public isPc!: boolean;

  // angularのdom elementを取得
  @ViewChild('add2FavoriteBtnEl', { static: false }) add2FavoriteBtnEl?: ElementRef<HTMLButtonElement>;
  @ViewChild('add2FavoriteIconEl', { static: false }) add2FavoriteIconEl?: ElementRef<HTMLSpanElement>;

  /** コンストラクタ */
  constructor(
    protected _common: CommonLibService,
    protected _errorsHandlerSvc: ErrorsHandlerService,
    protected _requestService: ComplexFlightAvailabilityRequestService,
    protected _dataAdapterService: DataAdapterService,
    protected _favoritePostService: FavoritePostService,
    protected _loadingSvc: PageLoadingService,
    protected _storeService: ComplexFlightAvailabilityStoreService,
    protected _roundtripFlightAvailabilityInternationalService: RoundtripFlightAvailabilityInternationalService,
    protected _roundtripFlightAvailabilityInternationalPresService: RoundtripFlightAvailabilityInternationalPresService,
    private _changeDetectorRef: ChangeDetectorRef
  ) {
    super(_common);
  }

  /** 初期表示処理 */
  ngAfterViewInit(): void {
    this.initFavoriteIcon();
  }

  /** 初期表示処理 */
  init() {
    // お気に入り登録状態の更新を取得
    this.subscribeService(
      'isRegisteredFavoriteInit',
      this._roundtripFlightAvailabilityInternationalService.getRoundtripFlightAvailabilityInternationalObservable(),
      (data) => {
        this.favoriteFlag = !!data.isRegisteredFavorite;
        this.isNotFavoriteAnimation = !!data.isNotFavoriteAnimation;
        if (this.favoriteFlag && this.isNotFavoriteAnimation) {
          this.disabled = true;
          this.isFavoriteAdded = true;
        } else if (this.favoriteFlag && !this.isNotFavoriteAnimation) {
          this.disabled = false;
        }
        this._changeDetectorRef.markForCheck();
      }
    );
  }

  /** 画面終了時処理 */
  destroy() {
    this.deleteSubscription('isRegisteredFavoriteInit');
  }

  /** 画面更新時処理 */
  reload() {}

  // 初期処理
  public initFavoriteIcon() {
    if (this._animationAddToFavorite) return;

    // buttonのelementを取得
    const btn = this.add2FavoriteBtnEl?.nativeElement;
    if (!btn) return;

    // favoriteのelementを取得
    const icon = this.add2FavoriteIconEl?.nativeElement;
    if (!icon) return;

    // インスタンスを作成
    this._animationAddToFavorite = lottie.loadAnimation({
      container: icon,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      animationData: iconJson,
    });
  }

  /**
   * お気に入り追加ボタン押下
   */
  public addToFavorite(event: Event | MouseEvent): void {
    event.preventDefault();

    // buttonのelementを取得
    const btn = this.add2FavoriteBtnEl?.nativeElement;
    if (!btn) return;

    if (this.isFavoriteAdded) return;

    // animateを実行し
    this.isFavoriteAdded = true;
    this._animationAddToFavorite?.playSegments([0, 200], true);
    this._animationAddToFavorite?.addEventListener('complete', () => {
      this.disabled = true;
      this._changeDetectorRef.detectChanges();
    });

    // R01P032: 往復空席照会結果(国際)画面(R01-P030)のお気に入り追加ボタン押下時処理を行う。
    this._getFavoritePost();
  }

  /**
   * お気に入り登録APIを呼び出す
   */
  private async _getFavoritePost() {
    // 以下の項目を基に、お気に入り登録APIを呼び出す。
    const searchFlightObj = await this._storeService.fetchSearchFlightData();
    this._roundtripFlightAvailabilityInternationalPresService.addFavorite(searchFlightObj, 'P033');
  }
}
